import { Heading, Text, useMediaQuery } from '@chakra-ui/react';
import { theme } from '../../../assets/style/theme';
import { lineBreakToBr } from '../../../util';
import Section from '../../Layout/Section';

type Props = {
  type: string;
  bgPath: string;
  title: string;
  subtitle?: string;
  description: string;
};

function PageTitle({ type, bgPath, title, subtitle, description }: Props) {

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const types:any = {
   big: {
      title: isMobile ? '2xl' : '6xl',
      description: isMobile ? 'lg' : '4xl',
      paddingTop: isMobile ? 40 : 280,
      paddingBottom: isMobile ? 40 : 280,
      paddingLeft: isMobile ? 40 : 1,
      paddingRight: isMobile ? 40 : 1,
    },
    small: {
      title: isMobile ? 'xl' : '5xl',
      description: isMobile ? 'lg' : '2xl',
      paddingTop: isMobile ? 20 : 214,
      paddingBottom: isMobile ? 20 : 214,
      paddingLeft: isMobile ? 20 : 1,
      paddingRight: isMobile ? 20 : 1,
    }
  }

  const { title: titleSize, description: descriptionSize, paddingTop, paddingBottom, paddingLeft, paddingRight } = types[type];  

  return (
    <>
    <Section background="dgr" pt={paddingTop} pb={paddingBottom} pl={paddingLeft} pr={paddingRight} bgPath={bgPath}>
      {
        subtitle && (
          <Heading size="2xl" color="b.gr" paddingBottom='6'>
            {subtitle}
          </Heading>    
        )
      }
      <Heading size={titleSize} color="b.wh" paddingBottom='8'>
        {title}
      </Heading>
      <Text as="div" fontSize={descriptionSize} color="b.wh" >
        < p dangerouslySetInnerHTML={ {__html: lineBreakToBr(description) } } />
      </Text>
    </Section>
    </>
  );
}

PageTitle.defaultProps = {
  type: 'big'
};

export default PageTitle;
